import React from "react"
import LogoSvg from "./logo.svg"

const Logo = ({ className }) => {
  return <LogoSvg className={className} />
}

export default Logo
